import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PoDialogService, PoModalAction, PoModalComponent, PoNotificationService } from '@po-ui/ng-components';
import { PoPageLoginLiterals } from '@po-ui/ng-templates';
import { LoginService } from 'src/app/services/login/login.service';
import { SessionService } from 'src/app/services/session/session.service';
import { PasswordRecoverService } from 'src/app/services/password-recover/password-recover.service';
import { UtilService } from 'src/app/services/util-service/util.service';
import { IpServiceService } from 'src/app/services/ip-service/ip-service.service';
import { LgpdService } from 'src/app/services/lgpd.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private notificationService: PoNotificationService,
    private sessionService: SessionService,
    private router: Router,
    private loginService: LoginService,
    private passwordRecoverService: PasswordRecoverService,
    private ipService: IpServiceService,
    private utilService: UtilService,
    private lgpdService: LgpdService,
    private poAlert: PoDialogService,
  ) { }

  get controls() {
    return this.loginForm.controls;
  }

  @ViewChild('empresaModal', { static: true }) empresaModal: PoModalComponent;
  @ViewChild('modalErrorLogin', { static: true }) modalErrorLogin: PoModalComponent;
  @ViewChild('passwordRecoverModal', { static: true }) passwordRecoverModal: PoModalComponent;


  public loginForm: FormGroup;
  public loading = false;
  public empresaSelecionada: any;
  public origEmpresas: any;
  public disabledActionModal = true;
  private ipAddress: string;
  public isAprova = false;
  public contentModalError: string
  public subTitleModalError: string


  public htmlSafeLgpd = `
  <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01//EN" "http://www.w3.org/TR/html4/strict.dtd">
<HTML>
<HEAD>
<META http-equiv="Content-Type" content="text/html; charset=UTF-8">
<TITLE>pdf-html</TITLE>
<META name="generator" content="BCL easyConverter SDK 5.0.252">
<META name="author" content="Diogo Bittar">
<STYLE type="text/css">
body {margin-top: 0px;margin-left: 0px;}
#page_1 {position:relative; overflow: hidden;margin: 0px 0px 28px 113px;padding: 0px;border: none;width: 680px;}
#page_1 #id1_1 {border:none;margin: 0px 0px 0px 0px;padding: 0px;border:none;width: 680px;overflow: hidden;}
#page_1 #id1_2 {border:none;margin: 94px 0px 0px 83px;padding: 0px;border:none;width: 597px;overflow: hidden;}
#page_2 {position:relative; overflow: hidden;margin: 100px 0px 28px 113px;padding: 0px;border: none;width: 680px;}
#page_2 #id2_1 {border:none;margin: 0px 0px 0px 0px;padding: 0px;border:none;width: 680px;overflow: hidden;}
#page_2 #id2_2 {border:none;margin: 84px 0px 0px 83px;padding: 0px;border:none;width: 597px;overflow: hidden;}
#page_3 {position:relative; overflow: hidden;margin: 98px 0px 28px 113px;padding: 0px;border: none;width: 680px;}
#page_3 #id3_1 {border:none;margin: 0px 0px 0px 0px;padding: 0px;border:none;width: 680px;overflow: hidden;}
#page_3 #id3_2 {border:none;margin: 729px 0px 0px 83px;padding: 0px;border:none;width: 597px;overflow: hidden;}
.ft0{font: bold 15px 'Calibri';text-decoration: underline;line-height: 18px;}
.ft1{font: bold 15px 'Calibri';line-height: 18px;}
.ft2{font: 15px 'Calibri';margin-left: 29px;line-height: 18px;}
.ft3{font: 15px 'Calibri';line-height: 18px;}
.ft4{font: 15px 'Calibri';margin-left: 3px;line-height: 18px;}
.ft5{font: 15px 'Calibri';margin-left: 2px;line-height: 18px;}
.ft6{font: 15px 'Calibri';margin-left: 25px;line-height: 18px;}
.ft7{font: 1px 'Calibri';line-height: 1px;}
.ft8{font: 15px 'Calibri';line-height: 17px;}
.ft9{font: 1px 'Calibri';line-height: 17px;}
.ft10{font: 1px 'Calibri';line-height: 2px;}
.ft11{font: 14px 'Calibri';margin-left: 25px;line-height: 18px;}
.ft12{font: 14px 'Calibri';line-height: 18px;}
.ft13{font: 12px 'Calibri';line-height: 14px;}
.ft14{font: 15px 'Calibri';margin-left: 12px;line-height: 18px;}
.ft15{font: 15px 'Times New Roman';line-height: 17px;}
.ft16{font: 15px 'Calibri';margin-left: 17px;line-height: 18px;}
.ft17{font: bold 16px 'Calibri';line-height: 19px;}
.ft18{font: 15px 'Calibri';margin-left: 14px;line-height: 18px;}
.ft19{font: 14px 'Calibri';line-height: 17px;}
.ft20{font: 14px 'Calibri';margin-left: 25px;line-height: 17px;}
.p0{text-align: left;padding-left: 105px;margin-top: 0px;margin-bottom: 0px;}
.p1{text-align: left;margin-top: 42px;margin-bottom: 0px;}
.p2{text-align: justify;padding-right: 122px;margin-top: 22px;margin-bottom: 0px;}
.p3{text-align: left;margin-top: 24px;margin-bottom: 0px;}
.p4{text-align: left;margin-top: 2px;margin-bottom: 0px;}
.p5{text-align: left;padding-right: 122px;margin-top: 2px;margin-bottom: 0px;}
.p6{text-align: left;margin-top: 4px;margin-bottom: 0px;}
.p7{text-align: justify;padding-right: 113px;margin-top: 22px;margin-bottom: 0px;}
.p8{text-align: left;padding-left: 8px;margin-top: 0px;margin-bottom: 0px;white-space: nowrap;}
.p9{text-align: left;padding-left: 6px;margin-top: 0px;margin-bottom: 0px;white-space: nowrap;}
.p10{text-align: left;margin-top: 0px;margin-bottom: 0px;white-space: nowrap;}
.p11{text-align: right;padding-right: 7px;margin-top: 0px;margin-bottom: 0px;white-space: nowrap;}
.p12{text-align: left;margin-top: 21px;margin-bottom: 0px;}
.p13{text-align: justify;padding-right: 108px;margin-top: 18px;margin-bottom: 0px;}
.p14{text-align: justify;padding-right: 113px;margin-top: 23px;margin-bottom: 0px;}
.p15{text-align: justify;padding-right: 113px;margin-top: 24px;margin-bottom: 0px;}
.p16{text-align: left;margin-top: 0px;margin-bottom: 0px;}
.p17{text-align: left;padding-right: 113px;margin-top: 0px;margin-bottom: 0px;}
.p18{text-align: left;padding-left: 48px;padding-right: 113px;margin-top: 20px;margin-bottom: 0px;text-indent: -24px;}
.p19{text-align: justify;padding-right: 113px;margin-top: 20px;margin-bottom: 0px;}
.p20{text-align: left;margin-top: 46px;margin-bottom: 0px;}
.p21{text-align: justify;padding-right: 113px;margin-top: 16px;margin-bottom: 0px;}
.p22{text-align: left;padding-left: 24px;margin-top: 15px;margin-bottom: 0px;}
.p23{text-align: left;padding-left: 24px;margin-top: 0px;margin-bottom: 0px;}
.p24{text-align: left;padding-left: 24px;margin-top: 1px;margin-bottom: 0px;}
.p25{text-align: justify;padding-right: 113px;margin-top: 21px;margin-bottom: 0px;}
.p26{text-align: left;margin-top: 38px;margin-bottom: 0px;}
.p27{text-align: justify;padding-right: 113px;margin-top: 18px;margin-bottom: 0px;}
.p28{text-align: justify;padding-right: 108px;margin-top: 17px;margin-bottom: 0px;}
.p29{text-align: justify;padding-right: 108px;margin-top: 22px;margin-bottom: 0px;}
.p30{text-align: justify;padding-right: 113px;margin-top: 17px;margin-bottom: 0px;}
.td0{border-left: #000000 1px solid;border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 109px;vertical-align: bottom;}
.td1{border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 125px;vertical-align: bottom;}
.td2{border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 105px;vertical-align: bottom;}
.td3{border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 94px;vertical-align: bottom;}
.td4{border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 22px;vertical-align: bottom;}
.td5{border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 112px;vertical-align: bottom;}
.td6{border-left: #000000 1px solid;border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 109px;vertical-align: bottom;}
.td7{border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 86px;vertical-align: bottom;}
.td8{border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 39px;vertical-align: bottom;}
.td9{border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 65px;vertical-align: bottom;}
.td10{border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 40px;vertical-align: bottom;}
.td11{border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 94px;vertical-align: bottom;}
.td12{border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 22px;vertical-align: bottom;}
.td13{border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 112px;vertical-align: bottom;}
.td14{border-left: #000000 1px solid;border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 109px;vertical-align: bottom;}
.td15{padding: 0px;margin: 0px;width: 86px;vertical-align: bottom;}
.td16{border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 39px;vertical-align: bottom;}
.td17{padding: 0px;margin: 0px;width: 65px;vertical-align: bottom;}
.td18{border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 40px;vertical-align: bottom;}
.td19{padding: 0px;margin: 0px;width: 94px;vertical-align: bottom;}
.td20{border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 22px;vertical-align: bottom;}
.td21{border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 112px;vertical-align: bottom;}
.tr0{height: 19px;}
.tr1{height: 18px;}
.tr2{height: 17px;}
.tr3{height: 2px;}
.t0{width: 572px;margin-top: 21px;font: 15px 'Calibri';}
</STYLE>
</HEAD>
<BODY>
<DIV id="page_1">
<DIV id="id1_1">
<P class="p0 ft0">TERMO DE CIÊNCIA DE TRATAMENTO DE DADOS PESSOAIS</P>
<P class="p1 ft1">1. DA LEGISLAÇÃO AFETA AO OBJETO DO INSTRUMENTO</P>
<P class="p2 ft3"><SPAN class="ft1">1.1</SPAN><SPAN class="ft2">Sem prejuízo das demais normas legais que dispõem sobre a proteção da privacidade, intimidade, liberdade de expressão, livre iniciativa, livre concorrência, direitos humanos e dignidade da pessoa humana, este instrumento encontra respaldo na seguinte legislação, mas não limitado à:</SPAN></P>
<P class="p3 ft3"><SPAN class="ft3">-</SPAN><SPAN class="ft4">Artigo 5º, incisos IV, VI, VIII, IX e X da Constituição Federal.</SPAN></P>
<P class="p4 ft3"><SPAN class="ft3">-</SPAN><SPAN class="ft4">Lei 12.737/12: Dispõe sobre a tipificação de delitos informáticos.</SPAN></P>
<P class="p5 ft3"><SPAN class="ft3">-</SPAN><SPAN class="ft5">Lei 12.965/14: Estabelece princípios, garantias, direitos e deveres para uso da internet no Brasil.</SPAN></P>
<P class="p6 ft3"><SPAN class="ft3">-</SPAN><SPAN class="ft4">Lei 13.709/19: Lei Geral de Proteção de Dados.</SPAN></P>
<P class="p1 ft1">2. DO TRATAMENTO DE DADOS</P>
<P class="p7 ft3"><SPAN class="ft3">2.1.</SPAN><SPAN class="ft6">Considerando a disciplina da legislação acerca da Proteção de Dados Pessoais, o Grupo FSB elenca os dados que o Prestador de Serviço deverá fornecer para exercício do objeto do Contrato de Prestação de Serviços e que serão tratados e compartilhados para determinados fins também elencados no presente termo:</SPAN></P>
<TABLE cellpadding=0 cellspacing=0 class="t0">
<TR>
<TD class="tr0 td0"><P class="p8 ft3">Nome</P></TD>
<TD colspan=2 class="tr0 td1"><P class="p9 ft3">Nacionalidade</P></TD>
<TD colspan=2 class="tr0 td2"><P class="p9 ft3">Estado Civil</P></TD>
<TD class="tr0 td3"><P class="p9 ft3">Data</P></TD>
<TD class="tr0 td4"><P class="p10 ft3">de</P></TD>
<TD class="tr0 td5"><P class="p9 ft3">Formação</P></TD>
</TR>
<TR>
<TD class="tr1 td6"><P class="p8 ft3">Completo</P></TD>
<TD class="tr1 td7"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td8"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td9"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td10"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td11"><P class="p9 ft3">Nascimento</P></TD>
<TD class="tr1 td12"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td13"><P class="p9 ft3">acadêmica</P></TD>
</TR>
<TR>
<TD class="tr2 td14"><P class="p8 ft8">Endereço</P></TD>
<TD class="tr2 td15"><P class="p9 ft8">Registro</P></TD>
<TD class="tr2 td16"><P class="p10 ft8">Geral</P></TD>
<TD class="tr2 td17"><P class="p9 ft8">Cadastro</P></TD>
<TD class="tr2 td18"><P class="p11 ft8">de</P></TD>
<TD class="tr2 td19"><P class="p9 ft8">Imagem</P></TD>
<TD class="tr2 td20"><P class="p10 ft9">&nbsp;</P></TD>
<TD class="tr2 td21"><P class="p9 ft8">Dados Bancários</P></TD>
</TR>
<TR>
<TD class="tr1 td14"><P class="p8 ft3">Completo</P></TD>
<TD class="tr1 td15"><P class="p9 ft3">(RG)</P></TD>
<TD class="tr1 td16"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td17"><P class="p9 ft3">Pessoa</P></TD>
<TD class="tr1 td18"><P class="p11 ft3">Física</P></TD>
<TD class="tr1 td19"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td20"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td21"><P class="p10 ft7">&nbsp;</P></TD>
</TR>
<TR>
<TD class="tr1 td14"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td15"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td16"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td17"><P class="p9 ft3">(CPF)</P></TD>
<TD class="tr1 td18"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td19"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td20"><P class="p10 ft7">&nbsp;</P></TD>
<TD class="tr1 td21"><P class="p10 ft7">&nbsp;</P></TD>
</TR>
<TR>
<TD class="tr3 td6"><P class="p10 ft10">&nbsp;</P></TD>
<TD class="tr3 td7"><P class="p10 ft10">&nbsp;</P></TD>
<TD class="tr3 td8"><P class="p10 ft10">&nbsp;</P></TD>
<TD class="tr3 td9"><P class="p10 ft10">&nbsp;</P></TD>
<TD class="tr3 td10"><P class="p10 ft10">&nbsp;</P></TD>
<TD class="tr3 td11"><P class="p10 ft10">&nbsp;</P></TD>
<TD class="tr3 td12"><P class="p10 ft10">&nbsp;</P></TD>
<TD class="tr3 td13"><P class="p10 ft10">&nbsp;</P></TD>
</TR>
</TABLE>
<P class="p12 ft3"><SPAN class="ft3">2.2.</SPAN><SPAN class="ft6">Para fins de adequação à legislação vigente, o Grupo FSB informa que será tratado como</SPAN></P>
<P class="p4 ft3">“DADO PESSOAL”, informação relacionada a pessoa natural identificada ou identificável.</P>
<P class="p13 ft12"><SPAN class="ft3">2.3.</SPAN><SPAN class="ft11">Ainda para fins de adequação à legislação vigente, o Grupo FSB informa que será tratado como “DADO PESSOAL SENSÍVEL”, informações sobre origem racial ou étnica, convicção religiosa, opinião política, organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural.</SPAN></P>
<P class="p14 ft3"><SPAN class="ft3">2.4.</SPAN><SPAN class="ft6">O Grupo FSB informa estes dados serão armazenados em banco de dados estruturado para o armazenamento de tais informações, garantida a sua segurança e uso correto dos dados e que estes dados estarão disponíveis para consulta por parte do Grupo FSB mediante solicitação prévia junto ao “Encarregado” designado.</SPAN></P>
<P class="p15 ft3"><SPAN class="ft3">2.5.</SPAN><SPAN class="ft6">O Prestador de Serviço dá ciência acerca do compartilhamento de seus dados pessoais por parte do Grupo FSB, com terceiros legítimos para as questões relacionadas ao contrato de prestação de serviços.</SPAN></P>
</DIV>
<DIV id="id1_2">
<P class="p16 ft13">Termo de Ciência de Tratamento de Dados Pessoais Versão 1.0, setembro de 2021</P>
</DIV>
</DIV>
<DIV id="page_2">
<DIV id="id2_1">
<P class="p17 ft3"><SPAN class="ft3">2.6</SPAN><SPAN class="ft2">Os dados pessoais do Prestador de Serviço serão compartilhados com as seguintes empresas com os determinados fins:</SPAN></P>
<P class="p18 ft3"><SPAN class="ft3">a)</SPAN><SPAN class="ft14">Madre Brasil Tecnologia LTDA – CNPJ: </SPAN><NOBR>25.391.307/0001-91</NOBR> – para análise, tratamento e repasse de valores;</P>
<P class="p19 ft3"><SPAN class="ft3">2.7.</SPAN><SPAN class="ft6">O Grupo FSB informa que manterá o tratamento dos dados pessoais compartilhados pelo Prestador de Serviço, por tempo indeterminado, enquanto vigente o Contrato de Prestação de Serviço;</SPAN></P>
<P class="p20 ft1">3. CIÊNCIA DO TRATAMENTO DE DADOS</P>
<P class="p21 ft3"><SPAN class="ft3">3.1.</SPAN><SPAN class="ft6">O Prestador de Serviço, na figura de titular dos dados pessoais, dá a sua ciência quanto a coleta, tratamento, uso e compartilhamento de dados pessoais e dados pessoais sensíveis por parte do Grupo FSB, para os seguintes fins:</SPAN></P>
<P class="p22 ft3"><SPAN class="ft15">•</SPAN><SPAN class="ft16">Para fins de cadastro;</SPAN></P>
<P class="p23 ft3"><SPAN class="ft15">•</SPAN><SPAN class="ft16">Para fins de empréstimo de equipamento;</SPAN></P>
<P class="p24 ft3"><SPAN class="ft15">•</SPAN><SPAN class="ft16">Para fins de recebimento de informações;</SPAN></P>
<P class="p24 ft3"><SPAN class="ft15">•</SPAN><SPAN class="ft16">Para fins de disponibilização de acesso ao sistema da empresa;</SPAN></P>
<P class="p23 ft3"><SPAN class="ft15">•</SPAN><SPAN class="ft16">Para fins de divulgação interna e ações de endomarketing;</SPAN></P>
<P class="p24 ft3"><SPAN class="ft15">•</SPAN><SPAN class="ft16">Para fins de fiscalização do poder público;</SPAN></P>
<P class="p24 ft3"><SPAN class="ft15">•</SPAN><SPAN class="ft16">Para fins de cumprimento de obrigação legal.</SPAN></P>
<P class="p25 ft3"><SPAN class="ft3">3.2.</SPAN><SPAN class="ft6">O Prestador de Serviço com a assinatura do presente termo de ciência, manifesta que procedeu com a sua leitura e manifesta a sua ciência acerca da política de tratamento de dados pessoais do Grupo FSB;</SPAN></P>
<P class="p26 ft17">4 – DAS POLÍTICAS INTERNAS</P>
<P class="p27 ft3"><SPAN class="ft3">4.1.</SPAN><SPAN class="ft6">O Prestador de Serviço, além da ciência as tratamento de seus dados pessoais, manifestará a partir da assinatura do presente termo, o total conhecimento da existência e do conteúdo da Política de Privacidade, Política de Segurança da Informação, Política de Criação de senhas, e demais políticas apresentadas;</SPAN></P>
<P class="p27 ft3"><SPAN class="ft3">4.1.1.</SPAN><SPAN class="ft18">Fica ciente o Prestador de Serviço que as políticas internas citadas passam a fazer parte do dever como prestador de serviço, estando incorporadas ao regramento já previsto no contrato de prestação de serviço;</SPAN></P>
<P class="p28 ft19"><SPAN class="ft19">4.2.</SPAN><SPAN class="ft20">O Prestador de Serviço manifesta que todas as todas as informações prestadas se encontram corretas, </SPAN><NOBR>responsabilizando-se</NOBR> em garantir a boa governança dos dados pessoais de colaboradores, prestadores de serviço e clientes que por ventura puder acessar, conforme políticas de segurança da informação e de tratamento de dados pessoais já apresentadas;</P>
<P class="p29 ft19"><SPAN class="ft19">4.3.</SPAN><SPAN class="ft20">O Prestador de Serviço dará a sua plena e irrevogável ciência que a partir da assinatura do presente termo, a não observância das políticas internas caracterizará em violação às cláusulas do contrato assinado, estando ainda passível de aplicação das penalidades cabíveis,</SPAN></P>
</DIV>
<DIV id="id2_2">
<P class="p16 ft13">Termo de Ciência de Tratamento de Dados Pessoais Versão 1.0, setembro de 2021</P>
</DIV>
</DIV>
<DIV id="page_3">
<DIV id="id3_1">
<P class="p17 ft3">graduadas em função da gravidade e da reiteração, conforme disposto no Contrato de Prestação de Serviços celebrado;</P>
<P class="p30 ft3"><SPAN class="ft3">4.4.</SPAN><SPAN class="ft6">O Prestador de Serviço manifesta a sua ciência de que as políticas internas apresentadas não invalidam nenhuma das cláusulas do contrato de prestação de serviços, bem como, das demais regras estabelecidas pelo Grupo FSB, dando ciência que o respeito as políticas internas é a conduta a ser seguida por todos os Prestadores de Serviço.</SPAN></P>
<P class="p26 ft17">5 – DO ACEITE</P>
<P class="p27 ft3"><SPAN class="ft3">5.1.</SPAN><SPAN class="ft6">Ao clicar em “aceito” o Prestador de Serviço declara que leu todos os itens anteriores, bem como aceita os termos e condições apresentados neste “TERMO DE CIÊNCIA DE TRATAMENTO DE DADOS PESSOAIS”.</SPAN></P>
</DIV>
<DIV id="id3_2">
<P class="p16 ft13">Termo de Ciência de Tratamento de Dados Pessoais Versão 1.0, setembro de 2021</P>
</DIV>
</DIV>
</BODY>
</HTML>
  `

  public htmlSafeLgpdRecusa = `
  <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01//EN" "http://www.w3.org/TR/html4/strict.dtd">
<HTML>
<HEAD>
<META http-equiv="Content-Type" content="text/html; charset=UTF-8">
<TITLE>pdf-html</TITLE>
<META name="generator" content="BCL easyConverter SDK 5.0.252">
<META name="author" content="Diogo Bittar">
<STYLE type="text/css">
body {margin-top: 0px;margin-left: 0px;}
#page_1 {position:relative; overflow: hidden;margin: 0px 0px 28px 113px;padding: 0px;border: none;width: 680px;}
#page_1 #id1_1 {border:none;margin: 0px 0px 0px 0px;padding: 0px;border:none;width: 680px;overflow: hidden;}
#page_1 #id1_2 {border:none;margin: 94px 0px 0px 83px;padding: 0px;border:none;width: 597px;overflow: hidden;}
#page_2 {position:relative; overflow: hidden;margin: 100px 0px 28px 113px;padding: 0px;border: none;width: 680px;}
#page_2 #id2_1 {border:none;margin: 0px 0px 0px 0px;padding: 0px;border:none;width: 680px;overflow: hidden;}
#page_2 #id2_2 {border:none;margin: 84px 0px 0px 83px;padding: 0px;border:none;width: 597px;overflow: hidden;}
#page_3 {position:relative; overflow: hidden;margin: 98px 0px 28px 113px;padding: 0px;border: none;width: 680px;}
#page_3 #id3_1 {border:none;margin: 0px 0px 0px 0px;padding: 0px;border:none;width: 680px;overflow: hidden;}
#page_3 #id3_2 {border:none;margin: 729px 0px 0px 83px;padding: 0px;border:none;width: 597px;overflow: hidden;}
.ft0{font: bold 15px 'Calibri';text-decoration: underline;line-height: 18px;}
.ft1{font: bold 15px 'Calibri';line-height: 18px;}
.ft2{font: 15px 'Calibri';margin-left: 29px;line-height: 18px;}
.ft3{font: 15px 'Calibri';line-height: 18px;}
.ft4{font: 15px 'Calibri';margin-left: 3px;line-height: 18px;}
.ft5{font: 15px 'Calibri';margin-left: 2px;line-height: 18px;}
.ft6{font: 15px 'Calibri';margin-left: 25px;line-height: 18px;}
.ft7{font: 1px 'Calibri';line-height: 1px;}
.ft8{font: 15px 'Calibri';line-height: 17px;}
.ft9{font: 1px 'Calibri';line-height: 17px;}
.ft10{font: 1px 'Calibri';line-height: 2px;}
.ft11{font: 14px 'Calibri';margin-left: 25px;line-height: 18px;}
.ft12{font: 14px 'Calibri';line-height: 18px;}
.ft13{font: 12px 'Calibri';line-height: 14px;}
.ft14{font: 15px 'Calibri';margin-left: 12px;line-height: 18px;}
.ft15{font: 15px 'Times New Roman';line-height: 17px;}
.ft16{font: 15px 'Calibri';margin-left: 17px;line-height: 18px;}
.ft17{font: bold 16px 'Calibri';line-height: 19px;}
.ft18{font: 15px 'Calibri';margin-left: 14px;line-height: 18px;}
.ft19{font: 14px 'Calibri';line-height: 17px;}
.ft20{font: 14px 'Calibri';margin-left: 25px;line-height: 17px;}
.p0{text-align: left;padding-left: 105px;margin-top: 0px;margin-bottom: 0px;}
.p1{text-align: left;margin-top: 42px;margin-bottom: 0px;}
.p2{text-align: justify;padding-right: 122px;margin-top: 22px;margin-bottom: 0px;}
.p3{text-align: left;margin-top: 24px;margin-bottom: 0px;}
.p4{text-align: left;margin-top: 2px;margin-bottom: 0px;}
.p5{text-align: left;padding-right: 122px;margin-top: 2px;margin-bottom: 0px;}
.p6{text-align: left;margin-top: 4px;margin-bottom: 0px;}
.p7{text-align: justify;padding-right: 113px;margin-top: 22px;margin-bottom: 0px;}
.p8{text-align: left;padding-left: 8px;margin-top: 0px;margin-bottom: 0px;white-space: nowrap;}
.p9{text-align: left;padding-left: 6px;margin-top: 0px;margin-bottom: 0px;white-space: nowrap;}
.p10{text-align: left;margin-top: 0px;margin-bottom: 0px;white-space: nowrap;}
.p11{text-align: right;padding-right: 7px;margin-top: 0px;margin-bottom: 0px;white-space: nowrap;}
.p12{text-align: left;margin-top: 21px;margin-bottom: 0px;}
.p13{text-align: justify;padding-right: 108px;margin-top: 18px;margin-bottom: 0px;}
.p14{text-align: justify;padding-right: 113px;margin-top: 23px;margin-bottom: 0px;}
.p15{text-align: justify;padding-right: 113px;margin-top: 24px;margin-bottom: 0px;}
.p16{text-align: left;margin-top: 0px;margin-bottom: 0px;}
.p17{text-align: left;padding-right: 113px;margin-top: 0px;margin-bottom: 0px;}
.p18{text-align: left;padding-left: 48px;padding-right: 113px;margin-top: 20px;margin-bottom: 0px;text-indent: -24px;}
.p19{text-align: justify;padding-right: 113px;margin-top: 20px;margin-bottom: 0px;}
.p20{text-align: left;margin-top: 46px;margin-bottom: 0px;}
.p21{text-align: justify;padding-right: 113px;margin-top: 16px;margin-bottom: 0px;}
.p22{text-align: left;padding-left: 24px;margin-top: 15px;margin-bottom: 0px;}
.p23{text-align: left;padding-left: 24px;margin-top: 0px;margin-bottom: 0px;}
.p24{text-align: left;padding-left: 24px;margin-top: 1px;margin-bottom: 0px;}
.p25{text-align: justify;padding-right: 113px;margin-top: 21px;margin-bottom: 0px;}
.p26{text-align: left;margin-top: 38px;margin-bottom: 0px;}
.p27{text-align: justify;padding-right: 113px;margin-top: 18px;margin-bottom: 0px;}
.p28{text-align: justify;padding-right: 108px;margin-top: 17px;margin-bottom: 0px;}
.p29{text-align: justify;padding-right: 108px;margin-top: 22px;margin-bottom: 0px;}
.p30{text-align: justify;padding-right: 113px;margin-top: 17px;margin-bottom: 0px;}
.td0{border-left: #000000 1px solid;border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 109px;vertical-align: bottom;}
.td1{border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 125px;vertical-align: bottom;}
.td2{border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 105px;vertical-align: bottom;}
.td3{border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 94px;vertical-align: bottom;}
.td4{border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 22px;vertical-align: bottom;}
.td5{border-right: #000000 1px solid;border-top: #000000 1px solid;padding: 0px;margin: 0px;width: 112px;vertical-align: bottom;}
.td6{border-left: #000000 1px solid;border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 109px;vertical-align: bottom;}
.td7{border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 86px;vertical-align: bottom;}
.td8{border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 39px;vertical-align: bottom;}
.td9{border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 65px;vertical-align: bottom;}
.td10{border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 40px;vertical-align: bottom;}
.td11{border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 94px;vertical-align: bottom;}
.td12{border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 22px;vertical-align: bottom;}
.td13{border-right: #000000 1px solid;border-bottom: #000000 1px solid;padding: 0px;margin: 0px;width: 112px;vertical-align: bottom;}
.td14{border-left: #000000 1px solid;border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 109px;vertical-align: bottom;}
.td15{padding: 0px;margin: 0px;width: 86px;vertical-align: bottom;}
.td16{border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 39px;vertical-align: bottom;}
.td17{padding: 0px;margin: 0px;width: 65px;vertical-align: bottom;}
.td18{border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 40px;vertical-align: bottom;}
.td19{padding: 0px;margin: 0px;width: 94px;vertical-align: bottom;}
.td20{border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 22px;vertical-align: bottom;}
.td21{border-right: #000000 1px solid;padding: 0px;margin: 0px;width: 112px;vertical-align: bottom;}
.tr0{height: 19px;}
.tr1{height: 18px;}
.tr2{height: 17px;}
.tr3{height: 2px;}
.t0{width: 572px;margin-top: 21px;font: 15px 'Calibri';}
</STYLE>
</HEAD>
<BODY>
<DIV id="page_1">
<DIV id="id1_1">
<P class="p3 ft3"><SPAN class="ft3"></SPAN><SPAN class="ft4">Ao clicar em 'Recusar Termos', não será possível o acesso ao Portal. Por favor, envie um e-mail com seus questionamentos ao juridico@fsb.com.br caso deseje recusar.</SPAN></P>
<P class="p3 ft3"><SPAN class="ft3"></SPAN><SPAN class="ft4">Caso contrário, pedimos que leia o documento e, estando de acordo, clique em 'Aceitar Termos'.</SPAN></P>
</DIV>
</DIV>
</BODY>
</HTML>
  `

  public passwordRecoverForm = this.fb.group({
    cnpj: ['', [Validators.required, Validators.maxLength(14), Validators.minLength(14)]]
  });

  public tableEmpresasColumns: Array<any> = [
    { property: 'cnpj', label: 'CNPJ', width: '50%' },
    { property: 'nome', label: 'Descricao Empresa', width: '50%' },
    { property: 'codigoFilial', label: 'Codigo Filial', width: '15%', visible: false },
    { property: 'codigoGrupo', label: 'Codigo Grupo', width: '15%', visible: false },
    { property: 'descricaoEmpresa', label: 'Descricao Empresa', visible: false },
    { property: 'descricaoGrupo', label: 'Descricao Grupo', visible: false },
  ];


  public tableEmpresasItems = [];

  customLiterals: PoPageLoginLiterals = {
    loginPlaceholder: 'Insira seu usuário de acesso',
    passwordPlaceholder: 'Insira sua senha de acesso',
    submitLabel: 'Acessar sistema',
    loginHint: 'Insira o seu usuário do Protheus'
  };

  confirm: PoModalAction = {
    label: 'Ok',
    disabled: true,
    action: () => {
      if (this.empresaSelecionada === undefined || this.empresaSelecionada === null) {
        this.notificationService.warning('Selecione uma empresa!');
        return;
      }

      this.sessionService.nomeEmpresa = this.empresaSelecionada.nome;

      this.sessionService.setTenantID(this.empresaSelecionada.codigoGrupo, this.empresaSelecionada.codigoFilial);
      this.router.navigate(['home']);
      this.empresaModal.close();
    }
  };

  cancel: PoModalAction = {
    label: 'Cancelar', action: () => {
      this.controls.empresa.setValue('');
      this.empresaModal.close();
    }
  };

  public selected(event) {
    this.empresaSelecionada = event;
    this.confirm.disabled =
      this.empresaSelecionada === undefined ||
        this.empresaSelecionada === null ? true : false;
  }

  public unSelected(event) {
    this.empresaSelecionada = undefined;
    this.confirm.disabled =
      this.empresaSelecionada === undefined ||
        this.empresaSelecionada === null ||
        this.empresaSelecionada === {} ? true : false;
  }

  // ********************************************************************************************************************
  //                                                METODOS MODAL LGPD
  // ********************************************************************************************************************

  @ViewChild('lgpdModal', { static: true }) lgpdModal: PoModalComponent;

  aceitarLgpd: PoModalAction = {
    label: 'Aceitar',
    action: () => {
      this.postLgpd(true);
    }
  };



  recusarLgpd: PoModalAction = {
    label: 'Recusar', danger: true, action: () => {
      this.lgpdRecusaModal.open();
    }
  };

  // ********************************************************************************************************************
  //                                                METODOS MODAL RECUSA LGPD
  // ********************************************************************************************************************

  @ViewChild('lgpdRecusaModal', { static: true }) lgpdRecusaModal: PoModalComponent;

  recusarLgpdPrimary: PoModalAction = {
    label: 'Aceitar Termos', action: () => {
      this.postLgpd(true)
    }
  }

  recusarLgpdSecondary: PoModalAction = {
    label: 'Recusar Termos', danger: true, action: () => {
      this.postLgpd(false)
    }
  };

  ngOnInit() {
    this.loginForm = this.fb.group({
      empresa: ['', [
        Validators.required,
        Validators.minLength(14)
      ]],
      username: ['', [
        // Validators.pattern("^[0-9]*$"),
        Validators.required
      ]],
      password: ['', [
        Validators.required
      ]]
    });

    this.sessionService.isLogged$.subscribe((data) => {
      if (data && this.router.url === '/login') {
        this.router.navigate(['home']);
      }
    });

    this.getIP();
  }

  login(form) {
    this.loading = true;

    const { username, password, empresa } = form;

    this.sessionService.generateToken().subscribe({
      next: (tokenData) => {
        const base64 = window.btoa(`${username};${password};${empresa}`);
        
        this.loginService.login({ pk: base64 }).subscribe({
          next: (data: any) => {
            this.sessionService.isPJ = data.PJ;
            this.sessionService.login(base64);
            const dados = { ...data };
            delete dados.MENUS;
            this.sessionService.setInfo(dados);
            this.sessionService.emailGestor = data.EMAIL_GESTOR;
            this.sessionService.possuiLGPD = data['AI3_XALGPD'];
            if (data['AI3_XALGPD'] === '1') {
              const { sigamat } = data;
              if (sigamat.length <= 1) {
                const [empresa] = sigamat;
                this.sessionService.setTenantID(empresa.codigoGrupo, empresa.codigoFilial);
                this.sessionService.nomeEmpresa = empresa.nome;
                this.notificationService.success('Usuário logado!');
                this.router.navigate(['home']);
              } else {
                this.tableEmpresasItems = sigamat;
                this.empresaModal.open();
              }
            } else {
              this.lgpdModal.open();
            }
            this.loading = false;
          },
          error: (err) => {
            console.error(err);
            this.modalErrorDialog(err);
            this.loading = false;
          }
        });
      },
      error: (err) => {
        console.error('Erro ao gerar token', err);
        this.notificationService.error('Erro ao gerar token');
        this.loading = false;
      }
    });
  }

  public alertDialog(error: HttpErrorResponse){
    const titleDialog = 'Problema ao realizar o acesso ao portal'
    this.poAlert.alert({
      title: titleDialog,
      message: `${'Problema identificado: '} ${error.error.errorMessage}`,
      ok: () => {}
    })
  }

  public modalErrorDialog(error: HttpErrorResponse){
    const titleDialog = 'Problema ao realizar o acesso ao portal'
    this.modalErrorLogin.title = titleDialog
    this.subTitleModalError = "Problema identificado: "
    this.contentModalError = error.error.errorMessage
    // message: `${'Problema identificado: '} ${error.error.errorMessage}`
    this.modalErrorLogin.open()
    // action: () => {
    //   this.modalErrorDialog.close();
    // },
    // label: 'Voltar'
  }


  passwordRecover(form) {
    this.loading = true;
    this.passwordRecoverService
      .resetPassword(form)
      .subscribe(
        res => {
          console.error(res);
          this.passwordRecoverModal.close();
          this.notificationService.success('Senha resetada com sucesso. Verifique seu e-mail para mais informações.');
          this.loading = false;
        },
        err => {
          console.error(err);
          this.passwordRecoverModal.close();
          this.notificationService.error('Não foi possível resetar a senha. Por favor, entre em contato com o administrador.');
          this.loading = false;
        }
      );
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }


  postLgpd(isAprova: boolean) {
    this.loading = true;
    let userInformations;
    this.sessionService.info$
      .subscribe((data) => {
        userInformations = data;
      });

    const AI3_XALGPD = isAprova ? 1 : 2;
    const body = {
      RECNOAI3: userInformations['RECNOAI3'],
      AI3_XALGPD: AI3_XALGPD.toString(),
      AI3_XJLGPD: {
        data: this.utilService.multiFormataData(this.utilService.dataAtual(), 'dd/mm/yyyy'),
        hora: this.utilService.horaAtual(),
        ip: this.ipAddress,
        browser: this.utilService.getBrowserName()
      }
    }
    this.lgpdService.postLgpd(body)
      .subscribe((data) => {
        this.sessionService.possuiLGPD = data['AI3_XALGPD'];
        if (data['AI3_XALGPD'] === '1') {
          this.lgpdModal.close();
          this.lgpdRecusaModal.close();
          const sigamat = userInformations.sigamat;
          if (sigamat.length <= 1) {
            const [empresa] = sigamat;
            this.sessionService.setTenantID(empresa.codigoGrupo, empresa.codigoFilial);
            this.sessionService.nomeEmpresa = empresa.nome;
            this.notificationService.success('Usuário logado!');
            this.router.navigate(['home']);
          } else {
            this.tableEmpresasItems = sigamat;
            this.empresaModal.open();
          }
        } else {
          if (!isAprova) {
            this.lgpdModal.close();
            this.lgpdRecusaModal.close();
            this.sessionService.logout();
          }
        }
        this.loading = false;
      }, (err) => {
        console.error(err);
        this.loading = false;
      });
  }
}
